module.exports = __webpack_public_path__ + "static/img/9.-Programmer-Cable.2262573.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_images/9.-Programmer-Cable.jpg
// module id = F51x
// module chunks = 1